import React, { Fragment } from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans, useTranslation } from "react-i18next";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MDContainer from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import { Link as RouterLink } from "react-router-dom";
import { Route } from "react-router";
import MyPictureSetsPage from "../MyPictureSets/MyPictureSets";
import MyPictureSetPage from "../MyPictureSet/MyPictureSet";
import AddPictureSetPage from "../AddPictureSet/AddPictureSet";
import MyOrdersPage from "../MyOrders/MyOrders";
import PersonIcon from "@mui/icons-material/Lock";
import EmailIcon from "@mui/icons-material/ManageAccounts";
import ContactInfoIcon from "@mui/icons-material/PinDrop";
import MyPictureSetsIcon from "@mui/icons-material/Photo";
import OrderHistoryIcon from "@mui/icons-material/History";
import BlockIcon from "@mui/icons-material/Block";
import CommunicationIcon from "@mui/icons-material/Chat";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import ListItemIcon from "@mui/material/ListItemIcon";
import MyContactInfoPage from "../MyContactInfo/MyContactInfo";
import ChangePasswordPage from "../ChangePassword/ChangePassword";
import MyCommunicationSettingsPage from "../MyCommunicationSettings/MyCommunicationSettings";
import AppBar from "../../Components/AppBar";
import CancelPicturePackagesPage from "../MyPictureSet/CancelPicturePackagesPage";
import { useAPI } from "../../../../lib/common";
import MyAccountYearbookPose from "@/react/Webshop/Mobile/Pages/MyAccountYearbookPose/MyAccountYearbookPose";
import MyAccountFavoritePictures from "@/react/Webshop/Mobile/Pages/MyAccountFavoritePictures/MyAccountFavoritePictures";
import DownloadMyDataPage from "@/react/Webshop/Mobile/Pages/DownloadMyDataPage/DownloadMyDataPage";
import DeleteAccountPage from "@/react/Webshop/Mobile/Pages/DeleteAccountPage/DeleteAccountPage";
import ChangeUsernamePage from "@/react/Webshop/Mobile/Pages/ChangeUsernamePage/ChangeUsernamePage";
import { styled } from "@mui/material";
const Container = styled("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
});
const ListItemLink = ({ icon, primary, to, }) => {
    return (React.createElement("li", null,
        React.createElement(ListItemButton, { component: RouterLink, to: to },
            icon ? React.createElement(ListItemIcon, null, icon) : null,
            React.createElement(ListItemText, { primary: primary }))));
};
const MyAccount = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Route, { exact: true, path: "/my-account", component: MyAccountPage }),
        React.createElement(Route, { exact: true, path: "/my-account/contact-info", component: MyContactInfoPage }),
        React.createElement(Route, { exact: true, path: "/my-account/communication", component: MyCommunicationSettingsPage }),
        React.createElement(Route, { exact: true, path: "/my-account/change-password", component: ChangePasswordPage }),
        React.createElement(Route, { exact: true, path: "/my-account/change-username", component: ChangeUsernamePage }),
        React.createElement(Route, { exact: true, path: "/my-account/orders/:orderUuid?", component: MyOrdersPage }),
        React.createElement(Route, { exact: true, path: "/my-account/add-picture-set", component: AddPictureSetPage }),
        React.createElement(Route, { exact: true, path: "/my-account/picture-sets", component: MyPictureSetsPage }),
        React.createElement(Route, { exact: true, path: "/my-account/picture-sets/:pictureSetUuid/yearbook-pose", component: MyAccountYearbookPose }),
        React.createElement(Route, { exact: true, path: "/my-account/picture-sets/:pictureSetUuid/yearbook-pose/:jobPoseUuid", component: MyAccountYearbookPose }),
        React.createElement(Route, { exact: true, path: "/my-account/picture-sets/:pictureSetUuid/favorites", component: MyAccountFavoritePictures }),
        React.createElement(Route, { exact: true, path: "/my-account/picture-sets/:pictureSetUuid", component: MyPictureSetPage }),
        React.createElement(Route, { exact: true, path: "/my-account/cancel-picture-packages", component: CancelPicturePackagesPage }),
        React.createElement(Route, { exact: true, path: "/my-account/delete", component: DeleteAccountPage }),
        React.createElement(Route, { exact: true, path: "/my-account/download-data", component: DownloadMyDataPage })));
};
const MyAccountPage = () => {
    const { t } = useTranslation();
    const [data, loading] = useAPI("/sections/my-account/ajax/get_account_data.php");
    if (loading) {
        return (React.createElement("div", null,
            React.createElement(Trans, null, "Fetching account settings")));
    }
    const { packageForInspectionSubjects } = data;
    const items = [
        {
            title: t("Update contact information"),
            icon: React.createElement(ContactInfoIcon, null),
            link: "/my-account/contact-info",
        },
        {
            title: t("Change password"),
            icon: React.createElement(PersonIcon, null),
            link: "/my-account/change-password",
        },
        {
            title: t("Change user name"),
            icon: React.createElement(EmailIcon, null),
            link: "/my-account/change-username",
        },
        {
            title: t("My picture sets"),
            icon: React.createElement(MyPictureSetsIcon, null),
            link: "/my-account/picture-sets",
        },
        {
            title: t("Order history"),
            icon: React.createElement(OrderHistoryIcon, null),
            link: "/my-account/orders",
        },
    ];
    if (packageForInspectionSubjects.length > 0) {
        items.push({
            title: t("Cancel picture packages"),
            icon: React.createElement(BlockIcon, null),
            link: "/my-account/cancel-picture-packages",
        });
    }
    items.push({
        title: t("Communication"),
        icon: React.createElement(CommunicationIcon, null),
        link: "/my-account/communication",
    });
    items.push({
        title: t("Download my data"),
        icon: React.createElement(DownloadIcon, null),
        link: "/my-account/download-data",
    });
    items.push({
        title: t("Delete my account"),
        icon: React.createElement(DeleteIcon, null),
        link: "/my-account/delete",
    });
    return (React.createElement(MobilePage, null,
        React.createElement(AppBar, null),
        React.createElement(PageHeader, null,
            React.createElement(Trans, null, "My account")),
        React.createElement(Container, null,
            React.createElement(MDContainer, null,
                React.createElement(Paper, null,
                    React.createElement(List, null, items.map((item, index) => {
                        return (React.createElement(Fragment, { key: index },
                            React.createElement(ListItemLink, { to: item.link, primary: item.title, icon: item.icon }),
                            index < items.length - 1 && React.createElement(Divider, null)));
                    })))))));
};
export default MyAccount;
